import { render } from "./VUELogin.vue?vue&type=template&id=308cdb94"
import script from "./VUELogin.vue?vue&type=script&lang=js"
export * from "./VUELogin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__